import * as React from "react";
import { Tooltip } from "../Tooltip";

export type CheckboxType = {
    id: string
    checked: boolean
    sportId: string
    leagueId: string
    onChange: (ev: React.ChangeEvent<HTMLInputElement>) => void,
    tooltipMessage: string
    showTooltip: boolean
    selectedLeagueId: string
}

export class Checkbox extends React.PureComponent<CheckboxType, {}> {
    render() {
        return (
            <span className="rj-checkbox rj-league-list__checkbox" data-uat="span-league-list-checkbox">
                <input id={this.props.id} type="checkbox" checked={this.props.checked} className="rj-checkbox__input rj-league-list__checkbox-input"
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                        this.props.onChange(ev);
                    }} 
					
					data-uat="input-league-list-checkbox" />

                <label htmlFor={this.props.id} className="rj-checkbox__label rj-league-list__checkbox-label" data-uat="label-league-list-checkbox">
                    {this.props.children}
                </label>
                {this.props.showTooltip && this.props.leagueId === this.props.selectedLeagueId &&
                <Tooltip message={this.props.tooltipMessage} shouldShow={this.props.showTooltip} />}
            </span>
        )
    }
}